module.exports = __webpack_public_path__ + "img/burglary.b8279f89.svg";